import { render, staticRenderFns } from "./OrganizationsListView.vue?vue&type=template&id=6e7bee28&scoped=true&"
import script from "./OrganizationsListView.vue?vue&type=script&lang=js&"
export * from "./OrganizationsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7bee28",
  null
  
)

export default component.exports